import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivel1 = props => {
  return (
  <option dato1={props.elemento.codigoDpto} value={props.elemento._id}>{props.elemento.descrDpto}</option>
)
};

const Lista = ({handleLista, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const AddCiu2 = ({styles, list, handleLista, handleSubmit, handleChange, args, errors}) => {
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Ciudad nueva
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Código</label>
                  <Form.Input autoComplete="off" name="codigoCiudad" id="codigoCiudad" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoCiudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="nombreCiudad" id="nombreCiudad" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'nombreCiudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Código municipio DANE</label>
                  <Form.Input autoComplete="off" name="codigoMunicipioDANE" id="codigoMunicipioDANE" onChange={handleChange} placeholder='Código municipio DANE' icon={!errors.length?null: _find(errors, {path:'codigoMunicipioDANE'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Código postal</label>
                  <Form.Input autoComplete="off" name="codigoPostalDANE" id="codigoPostalDANE" onChange={handleChange} placeholder='Código postal' icon={!errors.length?null: _find(errors, {path:'codigoPostalDANE'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Código interno</label>
                  <Form.Input autoComplete="off" name="codigoCiudadInterno" id="codigoCiudadInterno" onChange={handleChange} placeholder='Código interno' icon={!errors.length?null: _find(errors, {path:'codigoCiudadInterno'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Código de barras</label>
                  <Form.Input autoComplete="off" name="codBarrasRdo" id="codBarrasRdo" onChange={handleChange} placeholder='Código de barras' icon={!errors.length?null: _find(errors, {path:'codBarrasRdo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Departamento</label>
                  <Lista list={list} styles={styles} handleLista={handleLista} />
                </Form.Field>

                <Button type='submit' primary fluid>
                  Agregar
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddCiu2
